import { colors, borderRadius } from './tokens'

export const styles = {
    buttonPrimary: (isEnabled) => ({
        flex: 1,
        padding: '0.875rem 1.5rem',
        fontSize: '0.875rem',
        fontWeight: 500,
        color: colors.white,
        backgroundColor: isEnabled ? colors.accent : colors.border,
        border: 'none',
        borderRadius: borderRadius.sm,
        cursor: isEnabled ? 'pointer' : 'not-allowed',
        transition: 'all 0.2s'
    }),

    buttonOutline: {
        padding: '0.875rem 1.5rem',
        fontSize: '0.875rem',
        fontWeight: 500,
        color: colors.primary,
        backgroundColor: 'transparent',
        border: `1px solid ${colors.primary}`,
        borderRadius: borderRadius.sm,
        cursor: 'pointer'
    },

    clientTypeButton: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.75rem',
        padding: '1.5rem',
        border: `2px solid ${colors.border}`,
        borderRadius: borderRadius.md,
        backgroundColor: colors.card,
        cursor: 'pointer',
        transition: 'all 0.2s'
    },

    input: {
        width: '100%',
        padding: '0.875rem 1rem',
        border: `1px solid ${colors.border}`,
        borderRadius: borderRadius.sm,
        fontSize: '1rem',
        boxSizing: 'border-box',
        outline: 'none'
    },

    modalOverlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000
    },

    modalContent: (maxWidth = '500px') => ({
        backgroundColor: colors.card,
        borderRadius: borderRadius.lg,
        padding: '2rem',
        width: '100%',
        maxWidth,
        maxHeight: '90vh',
        overflow: 'auto'
    }),

    iconCircle: (color, size = '64px') => ({
        width: size,
        height: size,
        backgroundColor: `${color}20`,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 1.5rem'
    }),

    sectionBox: {
        backgroundColor: colors.background,
        borderRadius: borderRadius.md,
        padding: '1.25rem',
        marginBottom: '1.5rem'
    },

    sectionTitle: {
        fontSize: '0.9375rem',
        fontWeight: 600,
        color: colors.primary,
        margin: '0 0 1rem 0',
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem'
    },

    dropzone: (isActive) => ({
        border: `2px dashed ${isActive ? colors.accent : colors.border}`,
        borderRadius: borderRadius.md,
        padding: '3rem',
        textAlign: 'center',
        cursor: 'pointer',
        backgroundColor: isActive ? `${colors.accent}10` : 'transparent',
        transition: 'all 0.2s'
    }),

    fileItem: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '1rem',
        backgroundColor: colors.background,
        borderRadius: borderRadius.sm,
        border: `1px solid ${colors.border}`
    },

    previewImage: (height = '80px') => ({
        marginTop: '0.5rem',
        borderRadius: borderRadius.sm,
        overflow: 'hidden',
        height
    })
}